import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { AuthenticationFacade } from '../+state';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable()
export class UnAuthenticationTokenGuard implements CanActivate {
  public currentRoute: string;
  constructor(private authenticationFacade: AuthenticationFacade) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authenticationFacade.getAuthenticationToken().pipe(
      map((authToken) => {
        if (state.url.includes('login')) {
          return !authToken;
        }
        return true;
      }),
      catchError((error) => {
        console.log(error);
        this.authenticationFacade.logoutSuccess();
        return of(false);
      })
    );
  }
}
